<template>
  <BaseFrame :idText='idText' @save='submit' :id='id+""'
    :infosArr='titleInfo' @clear='clearAll' saveText="保存" :saveLoading='saveLoading'
    :logText="$route.name!=='supplierGeneralAdd'?'操作日志':''" :logData='records' :able='able'
    @hanldeLog='getRecord'>
    <lk-form slot='content'>
      <BaseSupplier v-model="supplierForm"
      v-if="baseSupplierShow"
      @onNameChanged='onNameChanged'
      :able='able'
      :scopeLists='scopeLists'
      ref='supplierInfo'>
      </BaseSupplier>

      <DTPModal v-model="clearModal" content='重置将取消当前所做更改。' @confirm='reset' type='alert'>
      </DTPModal>
    </lk-form>
  </BaseFrame>
</template>
<script>
import BaseFrame from '../../../components/frame/BaseFrame.vue';
import utils from '../../../libs/utils';
import supplier from '../../../services/supplier';
import DTPModal from '../../../components/DTPModal.vue';
import mapState from '../../../mixins/mapState'; // 鉴权
import BaseSupplier from '../../../components/supplier';

export default {
  name: 'SupplierGeneralEdit',
  mixins: [mapState],
  components: {
    BaseFrame,
    DTPModal,
    BaseSupplier,
  },
  watch: {
    $route() {
      this.init();
    },
  },
  data() {
    return {
      baseSupplierShow: false,
      saveLoading: false,
      records: [],
      titleInfo: [],
      id: '',
      clearModal: false,
      able: false,
      idText: '',
      infos: null,
      tempForm: {},
      scopeLists: {
        drugProdLabelList: [],
        drugBizLabelList: [],
        equipmentProdLabelList: [],
        equipmentBizLabelList: [],
      },
      supplierForm: {

        id: '', // 主键
        memoryCode: '', // 助记码
        code: '', // 供应商编码
        name: '', // 供应商名称
        status: '', // 单据状态（1:启用；2:禁用；3:删除）
        rigistryFund: '', // 注册资金
        area: '', // 区域
        postCode: '', // 邮编
        qualityResponsible: '', // 质量负责人
        enterpriseType: [], // 企业类型
        corporationPerson: '', // 企业法人
        rigistryAddress: '', // 注册地址
        socialUnifyCreditCode: '', // 社会统一信用代码
        businessLicenceUrl: '', // 营业执照url
        businessLicenceRange: [],
        businessLicenceDate: '', // 营业执照发证日期 +
        businessLicenceEffecivePeroid: '', // 营业执照有效日期 +
        businessLicenceOffice: '', // 营业执照发证机关 +
        businessLicenceForever: false, // 营业执照永久 +

        drugProdScopeIds: '', // 药品生产范围
        drugProductCredentailCode: '', // 药品生产许可证号
        drugProductCredentailUrl: '', // 药品生产许可证证件照url
        drugProductRange: [], // 药品生产期限
        drugProductDate: '', // 药品生产许可证发证日期
        drugProductEffecivePeroid: '', // 药品生产许可证有效期限
        drugProductOffice: '', // 药品生产许可证发证机关
        gmpCode: '',
        gmpUrl: '', // gmp证书证件照url
        gmpRange: [], // gmp证书证件
        gmpCredentailDate: '', // gmp证书发证日期
        gmpEffecivePeroid: '', // gmp证书有效期限
        gmpCredentailOffice: '', // gmp证书发证机关

        drugBizScopeIds: '', // 药品经营范围
        drugBusinessCredentailUrl: '', // 药品经营许可证证件照url
        drugBusinessCredentailCode: '',
        drugBusinessRange: [], // 药品经营许可证证件照url
        drugBusinessEffecivePeroid: '', // 药品经营许可证有效期限
        drugBusinessOffice: '', // 药品经营许可证发证机关
        drugBusinessDate: '', // 药品经营许可证发证日期
        gspUrl: '', // gsp证书证件照url
        gspCode: '',
        gspRange: [], // gsp证书证件
        gspCredentailOffice: '', // gsp证书发证机关
        gspCredentailDate: '', // gsp证书发证日期
        gspEffecivePeroid: '', // gsp证书有效期限

        equipmentProdScopeIds: '',
        equipmentProdUrl: '',
        equipmentProdCode: '',
        equipmentProdRange: [],
        equipmentProdDate: '',
        equipmentProdExpiry: '',
        equipmentProdOffice: '',

        equipmentBizScopeIds: '',
        secondMediEquiCode: '', // 二类医疗器械生产（经营）企业许可证号
        secondMediEquiUrl: '', // 二类医疗器械生产（经营）企业许可证证件照url
        secondMediEquiCredOffice: '', // 二类医疗器械生产（经营）许可证发证机关
        secondMediEquiCredDate: null, // 二类医疗器械生产（经营）许可证发证日期

        thirdMediEquiCode: '', // 三类医疗器械生产（经营）企业许可证号
        thirdMediEquiUrl: '', // 三类医疗器械生产（经营）企业许可证证件照url
        thirdMediEquiRange: [], // 三类医疗器械生产（经营）企业许可证证件照url
        thirdMediEquiEffecPeroid: '', // 三类医疗器械生产（经营）许可证有效期限
        thirdMediEquiCredOffice: '', // 三类医疗器械生产（经营）许可证发证机关
        thirdMediEquiCredDate: '', // 三类医疗器械生产（经营）许可证发证日期

        foodCredentailCode: '', // 食品生产许可证号
        foodCredentailUrl: '', // 食品生产许可证证件照url
        foodCredentailRange: [], // 食品生产许可证证件照url
        foodEffecivePeroid: '', // 食品生产许可证有效期限
        foodCredentialOffice: '', // 食品生产许可证发证机关
        foodCredentailDate: '', // 食品生产许可证发证日期

        foodBizUrl: '',
        foodBizExpiry: '',
        foodBizOffice: '',
        foodBizDate: '',
        foodBizCode: '',
        foodBizRange: [],

        cosmeticCredentailUrl: '', // 化妆品生产企业卫生许可证证件照url
        cosmeticCredentailCode: '', // 化妆品生产企业卫生许可证号
        cosmeticCredentailOffice: '', // 化妆品生产企业卫生许可证发证机关
        cosmeticCredentailRange: [],
        cosmeticCredentailDate: '',
        cosmeticCredentailPeroid: '',

        otherCredentailUrl: '', // 其他证件证件照url
        otherCredentailCode: '', // 其他证件证件证号
        otherCredentailOffice: '', // 其他证件证件发证机关
        otherCredentailRange: [],
        otherCredentailDate: '',
        otherCredentailPeroid: '',

        otherLicense2Url: '',
        otherLicense2Code: '',
        otherLicense2Office: '',
        otherLicense2Range: [],
        otherLicense2Date: '',
        otherLicense2Expiry: '',
      },
    };
  },
  methods: {
    onNameChanged(name) {
      this.$store.commit('setDisableLoading', true);
      if (name) {
        supplier.mnemonicCode({ name }).then((res) => {
          if (res.data.status === 200) {
            this.supplierForm.memoryCode = res.data.data;
          }
        });
      } else {
        this.supplierForm.memoryCode = '';
      }
    },
    reset() {
      if (this.$route.name !== 'supplierGeneralAdd') {
        this.getInfos().then(() => {
          this.$store.commit('setLeaveModal', false);
        });
      } else {
        console.log(this.$refs);
        this.$refs.supplierInfo.confirmClear();
        // this.getScope();
      }
      this.clearModal = false;
      this.$nextTick(() => {
        this.$store.commit('setLeaveModal', false);
      });
    },
    clearAll() {
      this.clearModal = true;
    },
    getRecord() {
      this.$store.commit('setDisableLoading', true);
      supplier.getRecord({ originType: 1, refOriginId: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          // this.record
          this.records = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getTitleInfo() {
      return new Promise((resolve) => {
        supplier.supplierInfo({ originType: 1, id: this.$route.params.id }).then((res) => {
          if (res.data.status === 200) {
            const { data } = res.data;
            this.idText = '供应商编码';
            this.id = data.code;
            this.titleInfo = [
              { name: '供应商名称:', value: data.supplierName },
              { name: '创建人:', value: data.createUserName },
              { name: '创建时间:', value: data.createTime ? utils.exchangeTimeToSecond(data.createTime) : '' },
              { name: '最后修改人:', value: data.lastModifiedUserName },
              { name: '最后修改时间:', value: data.lastMmodifiedTime ? utils.exchangeTimeToSecond(data.lastMmodifiedTime) : '' },
            ];
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    submit() {
      this.$refs.supplierInfo.validateSubmit().then((msg) => {
        if (msg) {
          const temp = utils.deepClone(this.supplierForm);
          temp.businessLicenceDate = temp.businessLicenceRange[0];
          temp.businessLicenceEffecivePeroid = temp.businessLicenceRange[1];

          temp.gspCredentailDate = temp.gspRange[0];
          temp.gspEffecivePeroid = temp.gspRange[1];

          temp.gmpCredentailDate = temp.gmpRange[0];
          temp.gmpEffecivePeroid = temp.gmpRange[1];

          temp.drugProductDate = temp.drugProductRange[0];
          temp.drugProductEffecivePeroid = temp.drugProductRange[1];

          temp.drugBusinessDate = temp.drugBusinessRange[0];
          temp.drugBusinessEffecivePeroid = temp.drugBusinessRange[1];

          temp.equipmentProdDate = temp.equipmentProdRange[0];
          temp.equipmentProdExpiry = temp.equipmentProdRange[1];

          temp.thirdMediEquiCredDate = temp.thirdMediEquiRange[0];
          temp.thirdMediEquiEffecPeroid = temp.thirdMediEquiRange[1];

          temp.foodCredentailDate = temp.foodCredentailRange[0];
          temp.foodEffecivePeroid = temp.foodCredentailRange[1];

          temp.foodBizDate = temp.foodBizRange[0];
          temp.foodBizExpiry = temp.foodBizRange[1];

          temp.cosmeticCredentailDate = temp.cosmeticCredentailRange[0];
          temp.cosmeticCredentailPeroid = temp.cosmeticCredentailRange[1];

          temp.otherCredentailDate = temp.otherCredentailRange[0];
          temp.otherCredentailPeroid = temp.otherCredentailRange[1];

          temp.otherLicense2Date = temp.otherLicense2Range[0];
          temp.otherLicense2Expiry = temp.otherLicense2Range[1];
          // if (temp.secondMediEquiCredDate) {//王飞解释一下
          //   temp.secondMediEquiCredDate = (new Date(temp.secondMediEquiCredDate)).getTime();
          // }

          if (temp.enterpriseType) {
            temp.enterpriseType = temp.enterpriseType.join(',');
          }
          if (!temp.enterpriseType.includes('2')) {
            temp.drugProdScopeIds = [];
            temp.drugProductCredentailUrl = '';
            temp.drugProductCredentailCode = '';
            temp.drugProductRange = [];
            temp.drugProductOffice = '';
            temp.gmpUrl = '';
            temp.gmpCode = '';
            temp.gmpRange = [];
            temp.gmpCredentailOffice = '';
          }
          if (!temp.enterpriseType.includes('1') && !temp.enterpriseType.includes('2')) { // 剔除没有选择的企业类型的标签数据
            temp.drugBizScopeIds = [];
          }
          if (!temp.enterpriseType.includes('1')) {
            temp.drugBusinessCredentailUrl = '';
            temp.drugBusinessCredentailCode = '';
            temp.drugBusinessRange = [];
            temp.drugBusinessOffice = '';
            temp.gspUrl = '';
            temp.gspCode = '';
            temp.gspRange = [];
            temp.gspCredentailOffice = '';
          }
          if (!temp.enterpriseType.includes('3')) {
            temp.foodCredentailUrl = '';
            temp.foodCredentailCode = '';
            temp.foodCredentailRange = [];
            temp.foodCredentialOffice = '';
            temp.foodBizUrl = '';
            temp.foodBizCode = '';
            temp.foodBizRange = [];
            temp.foodBizOffice = '';
          }
          if (!temp.enterpriseType.includes('4')) {
            temp.equipmentProdScopeIds = [];
            temp.equipmentProdUrl = '';
            temp.equipmentProdCode = '';
            temp.equipmentProdRange = [];
            temp.equipmentProdOffice = '';
          }
          if (!temp.enterpriseType.includes('5') && !temp.enterpriseType.includes('4')) {
            temp.equipmentBizScopeIds = [];
          }
          if (!temp.enterpriseType.includes('5')) {
            temp.secondMediEquiUrl = '';
            temp.secondMediEquiCode = '';
            temp.secondMediEquiCredDate = '';
            temp.secondMediEquiCredOffice = '';
            temp.thirdMediEquiUrl = '';
            temp.thirdMediEquiCode = '';
            temp.thirdMediEquiRange = [];
            temp.thirdMediEquiCredOffice = '';
          }
          if (!temp.enterpriseType.includes('6')) {
            temp.cosmeticCredentailUrl = '';
            temp.cosmeticCredentailCode = '';
            temp.cosmeticCredentailRange = [];
            temp.cosmeticCredentailOffice = '';
          }
          if (temp.drugProdScopeIds) {
            temp.drugProdScopeIds = temp.drugProdScopeIds.join(',');
          }
          if (temp.drugBizScopeIds) {
            temp.drugBizScopeIds = temp.drugBizScopeIds.join(',');
          }
          if (temp.equipmentProdScopeIds) {
            temp.equipmentProdScopeIds = temp.equipmentProdScopeIds.join(',');
          }
          if (temp.equipmentBizScopeIds) {
            temp.equipmentBizScopeIds = temp.equipmentBizScopeIds.join(',');
          }
          this.saveLoading = true;
          if (temp.id) {
            supplier.SupplierGeneralUpdate(temp).then((res) => {
              this.handleChange = false;

              if (res.data.status === 200) {
                this.$Message.success('保存成功');
                this.$store.commit('setLeaveModal', false);
                setTimeout(() => {
                  this.saveLoading = false;
                  this.$router.push({ name: 'supplierGeneral' });
                }, 1000);
              } else {
                this.$Message.error(res.data.error);
                this.saveLoading = false;
              }
            }).catch((err) => {
              this.handleChange = false;
              this.saveLoading = false;
              utils.handleError(err);
            });
          } else {
            supplier.SupplierGeneralSave(temp).then((res) => {
              this.handleChange = false;

              if (res.data.status === 200) {
                this.$Message.success('保存成功');
                this.$store.commit('setLeaveModal', false);
                setTimeout(() => {
                  this.$router.push({ name: 'supplierGeneral' });
                  this.saveLoading = false;
                }, 1000);
              } else {
                this.saveLoading = false;
                this.$Message.error(res.data.error);
              }
            }).catch((err) => {
              this.handleChange = false;
              this.saveLoading = false;
              utils.handleError(err);
            });
          }
        } else {
          this.$Message.error('缺少必填项或信息不符合要求，请检查后再提交');
        }
      });
    },
    getInfos() {
      return new Promise((resolve) => {
        supplier.SupplierGeneralInfos({ id: this.$route.params.id }).then((res) => {
          if (res.data.status === 200) {
            const data = res.data.data.baseInfo;
            this.infosArr = [];
            data.businessLicenceRange = [];
            data.gspRange = [];
            data.gmpRange = [];
            data.drugProductRange = [];
            data.drugBusinessRange = [];
            data.equipmentProdRange = [];
            data.thirdMediEquiRange = [];
            data.foodCredentailRange = [];
            data.foodBizRange = [];
            data.cosmeticCredentailRange = [];
            data.otherLicense2Range = [];
            data.otherCredentailRange = [];
            if (data.businessLicenceEffecivePeroid) {
              data.businessLicenceRange[0] = data.businessLicenceDate;
              data.businessLicenceRange[1] = data.businessLicenceEffecivePeroid;
            }
            if (data.gspEffecivePeroid) {
              data.gspRange[0] = data.gspCredentailDate;
              data.gspRange[1] = data.gspEffecivePeroid;
            }
            if (data.gmpEffecivePeroid) {
              data.gmpRange[0] = data.gmpCredentailDate;
              data.gmpRange[1] = data.gmpEffecivePeroid;
            }

            if (data.drugProductEffecivePeroid) {
              data.drugProductRange[0] = data.drugProductDate;
              data.drugProductRange[1] = data.drugProductEffecivePeroid;
            }

            if (data.drugBusinessEffecivePeroid) {
              data.drugBusinessRange[0] = data.drugBusinessDate;
              data.drugBusinessRange[1] = data.drugBusinessEffecivePeroid;
            }

            if (data.equipmentProdExpiry) {
              data.equipmentProdRange[0] = data.equipmentProdDate;
              data.equipmentProdRange[1] = data.equipmentProdExpiry;
            }

            // if (data.secondMediEquiCredDate) {
            //   data.secondMediEquiCredDate = new Date(data.secondMediEquiCredDate);
            // }

            if (data.thirdMediEquiEffecPeroid) {
              data.thirdMediEquiRange[0] = data.thirdMediEquiCredDate;
              data.thirdMediEquiRange[1] = data.thirdMediEquiEffecPeroid;
            }

            if (data.foodEffecivePeroid) {
              data.foodCredentailRange[0] = data.foodCredentailDate;
              data.foodCredentailRange[1] = data.foodEffecivePeroid;
            }

            if (data.foodBizExpiry) {
              data.foodBizRange[0] = data.foodBizDate;
              data.foodBizRange[1] = data.foodBizExpiry;
            }

            if (data.cosmeticCredentailPeroid) {
              data.cosmeticCredentailRange[0] = data.cosmeticCredentailDate;
              data.cosmeticCredentailRange[1] = data.cosmeticCredentailPeroid;
            }
            if (data.otherCredentailPeroid) {
              data.otherCredentailRange[0] = data.otherCredentailDate;
              data.otherCredentailRange[1] = data.otherCredentailPeroid;
            }
            if (data.otherLicense2Expiry) {
              data.otherLicense2Range[0] = data.otherLicense2Date;
              data.otherLicense2Range[1] = data.otherLicense2Expiry;
            }
            data.enterpriseType = data.enterpriseType && data.enterpriseType.split(',');
            data.drugProdScopeIds = data.drugProdScopeIds && data.drugProdScopeIds.split(',');
            data.drugBizScopeIds = data.drugBizScopeIds && data.drugBizScopeIds.split(',');
            data.equipmentProdScopeIds = data.equipmentProdScopeIds && data.equipmentProdScopeIds.split(',');
            data.equipmentBizScopeIds = data.equipmentBizScopeIds && data.equipmentBizScopeIds.split(',');
            if (!data.enterpriseType) {
              data.enterpriseType = [];
            }
            Object.assign(this.supplierForm, data);
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getLabelList() {
      return new Promise((resolve) => {
        supplier.goodsLabelList({
          status: 1,
        }).then((res) => {
          if (res.data.status === 200 && res.data.data.list) {
            const { list } = res.data.data;
            list.forEach((item) => {
              const categoryIds = item.categoryIds.split(',');
              const goodsTypeIds = item.goodsTypeIds.split(',');
              if (categoryIds.includes('2') && (goodsTypeIds.includes('1') || goodsTypeIds.includes('3'))) {
                this.scopeLists.drugBizLabelList.push(item);
              }
              if (categoryIds.includes('3') && (goodsTypeIds.includes('1') || goodsTypeIds.includes('3'))) {
                this.scopeLists.drugProdLabelList.push(item);
              }
              if (categoryIds.includes('2') && goodsTypeIds.includes('2')) {
                this.scopeLists.equipmentBizLabelList.push(item);
              }
              if (categoryIds.includes('3') && goodsTypeIds.includes('2')) {
                this.scopeLists.equipmentProdLabelList.push(item);
              }
            });
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    init() {
      const routeName = this.$route.name;
      // const able = !( routeName=== 'supplierGeneralCheck');
      let Promises = [];
      if (routeName === 'supplierGeneralAdd') {
        Promises = [this.getLabelList()];
      } else {
        Promises = [this.getLabelList(), this.getTitleInfo(), this.getInfos()];
      }

      Promise.all(Promises).then(() => {
        this.baseSupplierShow = true;
        this.$nextTick(() => {
          this.$refs.supplierInfo.handleRoute();
        });
        this.able = !(routeName === 'supplierGeneralCheck');
      });
    },
  },
  mounted() {
    this.init();
  },
  // beforeRouteEnter(to, from, next) {
  //   if (to.name === 'supplierGeneralAdd') {
  //     next((vm) => {
  //       vm.getLabelList().then(() => {
  //         vm.baseSupplierShow = true;
  //         vm.$nextTick(() => {
  //           vm.$refs.supplierInfo.handleRoute();
  //         });
  //         vm.able = able;
  //       });
  //     });
  //   } else {
  //     next((vm) => {
  //       Promise.all([vm.getLabelList(), vm.getTitleInfo(), vm.getInfos()]).then(() => {
  //         vm.able = able;
  //         vm.baseSupplierShow = true;
  //         vm.$nextTick(() => {
  //           vm.$refs.supplierInfo.handleRoute();
  //         });
  //       });
  //     });
  //   }
  // },

};
</script>
<style lang="less" scoped>
.cardContainer{
  margin-bottom: 12px
}
.label{
  text-align-last: right;
  text-align: right;
  margin-left: -178px;
  width: 170px;
  float: left;
  line-height: 1;
}
</style>
